import { ConfigStateService, LocalizationService } from '@abp/ng.core';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { Store } from '@ngxs/store';
import { take } from 'rxjs';
import { SettingConstants } from 'src/core/constants/setting-constant';
import { AICoachingKpiOrganizationAveragesDto } from 'src/core/models/coaching-and-training/ai-coaching-kpi-organization-averages.dto';
import { AICoachingPeriodType } from 'src/core/models/enum/ai-coaching-period-type.enum';
import { TargetSelectionType } from 'src/core/models/enum/target-selection-type.enum';
import { FilterItemDto } from 'src/core/models/request/filter-item.dto';
import { Operators } from 'src/core/models/request/operator.enum';
import { UserGroupDto } from 'src/core/models/user-group/user-group.dto';
import { CoachingAndTrainingService } from 'src/core/services/coaching-and-training/coaching-and-training.service';
import { GlobalSettingsService } from 'src/core/services/settings/global-settings.service';

@Component({
  selector: 'ca-ai-coaching-settings',
  templateUrl: './ai-coaching-settings.component.html',
  styleUrls: ['./ai-coaching-settings.component.scss'],
  standalone: false,
})
export class AiCoachingSettingsComponent implements OnInit {
  aiCoachingPeriodTypes: Array<{ key: string; value: number }> = [];
  targetSelectionTypes: Array<{ key: string; value: number }> = [];
  orgAverages: AICoachingKpiOrganizationAveragesDto | null = null;

  userGroupSettingEnabled: boolean;
  systemStartDate: Date = new Date();
  userGroupSelectorOptions: any;
  userGroupSelectorFilters: FilterItemDto[] = [];
  startDate: Date;

  get form(): FormGroup {
    return this.formGroupDirective.form;
  }

  get selectedDepartments(): any[] {
    return this.form &&
      this.form.get('aiCoachingDepartments').value &&
      this.form.get('aiCoachingDepartments').value.selectedDepartments
      ? this.form.get('aiCoachingDepartments').value.selectedDepartments
      : [];
  }

  private readonly aiCoachingPrefix = 'AICoaching';
  private readonly aiCoachingStartDate = `${this.aiCoachingPrefix}.StartDate`;

  constructor(
    private formGroupDirective: FormGroupDirective,
    private store: Store,
    private config: ConfigStateService,
    private globalSettingsService: GlobalSettingsService,
    private operators: Operators,
    private localizationService: LocalizationService,
    private aiCoachingPeriodType: AICoachingPeriodType,
    private targetSelectionType: TargetSelectionType,
    private coachingService: CoachingAndTrainingService,
  ) {
    this.userGroupSettingEnabled =
      this.config.getSetting(SettingConstants.InteractionManagementEnabled).toLowerCase() ===
      'true';

    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var selectedDate = this.form.get('aiCoachingStartDate').value;

    if (selectedDate && selectedDate < today) {
      this.startDate = this.globalSettingsService.systemStartDate;
    } else {
      this.startDate = today;
    }

    this.userGroupSelectorOptions = {
      pageSize: 5,
      useSimpleFilter: true,
      queryOperator: this.operators.Contains,
      queryField: 'quickSearchTerm',
      emptyText: this.localizationService.instant('::SelectUserGroup'),
      multiple: true,
      url: UserGroupDto.apiUrl,
      currentPage: 1,
      showSelections: true,
      selectorPosition: 'Top',
    };

    this.userGroupSelectorFilters.push({
      field: 'includePassives',
      operator: this.operators.Equals,
      value: false,
    });

    this.aiCoachingPeriodTypes = Object.keys(this.aiCoachingPeriodType).map(key => ({
      key,
      value: this.aiCoachingPeriodType[key],
    }));

    this.targetSelectionTypes = Object.keys(this.targetSelectionType).map(key => ({
      key,
      value: this.targetSelectionType[key],
    }));
  }

  ngOnInit(): void {
    this.coachingService
      .getKpiOrganizationAverages()
      .pipe(take(1))
      .subscribe(averages => {
        this.orgAverages = averages;
      });
  }

  onDateChange(): void {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    this.startDate = today;
  }
}
